export enum FileUploadStatus {
	Queued,
	Uploading,
	UploadComplete,
	Completed,
	Failed,
	Canceled,
	UnsupportedFileType,
	Uploaded,
}

export enum UploadStatus {
	uploadSuccess = 3,
	uploadFailed = 6,
	unsupportedFile = 8,
}

export const FileUploadStatusString: Record<FileUploadStatus, string> = {
	[FileUploadStatus.Queued]: "Queued",
	[FileUploadStatus.Uploading]: "Uploading",
	[FileUploadStatus.UploadComplete]: "Upload Complete",
	[FileUploadStatus.Completed]: "Completed",
	[FileUploadStatus.Failed]: "Failed",
	[FileUploadStatus.Canceled]: "Cancelled",
	[FileUploadStatus.UnsupportedFileType]: "Unsupported File Type",
	[FileUploadStatus.Uploaded]: "Uploaded",
};

export interface IS3Config {
	bucket: string;
	region: string;
	cognitoRegion: string;
	cognitoIdentityPoolId: string;
	folderName: string;
}

export interface DriveFileUpload {
	/** Unique ID for UI/Saga lookup */
	id: string;

	/** File name e.g., "photo.jpg" */
	name: string;

	/** MIME type: "image/png", "application/pdf", etc. */
	type: string;

	/** File size in bytes */
	size: number;

	/** Full relative path when using folder upload */
	path?: string;

	/** Timestamp when the file was added */

	/** Optional: upload progress (0 → 100) */
	progress?: number;

	/** Optional: S3 URL after upload */
	uploadedUrl?: string;

	/** Optional: status for UI */
	status: FileUploadStatus;
}

export interface UploadProgress {
	progressName: string[];
	Total: number;
	Queued: number;
	Uploading: number;
	Completed: number;
	Canceled: number;
	Failed: number;
	UnSupportedFile: number;
	TotalProgPercent: number;
}

export interface FolderPath {
	pathHash: string;
	path: string;
	created: boolean;
}

export interface S3BucketInfo {
	loading: boolean;
	error: string | null;
	encryptedBucketInfo: string;
}

export interface Pagination {
	page: number;
	size: number;
}

export interface UploadState {
	s3BucketInfo: S3BucketInfo;
	files: DriveFileUpload[];
	folderCreatedPaths: Record<string, FolderPath>;
	inProgess: boolean;
	cancelled: boolean;
	cancelledList: string[];
	isExpendView: boolean;
	totalFileSize: number;
	uploadedFileSize: number;
	progress: UploadProgress;
	pagination: Pagination;
	error: string | null;
	fileSnoCounter: number;
	s3FolderName: string;
}

export const initialUploadState: UploadState = {
	s3BucketInfo: {
		loading: false,
		error: null,
		encryptedBucketInfo: "",
	},
	files: [],
	folderCreatedPaths: {},
	inProgess: false,
	cancelled: false,
	cancelledList: [],
	isExpendView: false,
	totalFileSize: 0,
	uploadedFileSize: 0,
	progress: {
		progressName: [],
		Total: 0,
		Queued: 0,
		Uploading: 0,
		Completed: 0,
		Canceled: 0,
		Failed: 0,
		UnSupportedFile: 0,
		TotalProgPercent: 0,
	},
	pagination: {
		page: 0,
		size: 25,
	},
	error: null,
	fileSnoCounter: 0,
	s3FolderName: "",
};

export interface errorlogpayload {
	orderid: number; // orderId
	objectType: number; //dropfile
	actionType: number; //add items
	sourceType: number; //web/device
	status: any; // error
	resourceName?: string; // filename
	resourcePath?: any; // s3path
	errorCode: any; // timeout
	errorDetail: string; // main error
	payload: any; //whole curl
	metadata?: string; // extra data
	clientDateTime: string; // date time
}
